import axios from "axios";

const getToken = async () => {
  try {
    const token = localStorage.getItem("token");
    return token;
  } catch (error) {
    return null;
  }
};

class Api {
  constructor() {
    this.client = null;
    this.api_url = "https://api.electrowiz.in/api";


  }
  
  init = (type) => {

    let headers;

    headers = {
      Accept: "application/json",
    }

    if (type === "multipart/form-data") {
      headers = {
        'Content-Type': 'multipart/form-data',
      }
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
    });

    this.client.interceptors.request.use(async (config) => {
      const token = await getToken();

      config.headers["Authorization"] = `Bearer ${token}`
      return config;
    }, (error) => {
      throw error;
    })

    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401 && localStorage.getItem("token")) {
          sessionStorage.setItem("logoutReason", "passwordChanged");
          localStorage.clear();
          if (window.location.pathname !== "/login") {
            // come back to the same page after logging in again
            window.location.assign(`/login?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`);
          }
        }
        return Promise.reject(error);
      }
    );

    return this.client;
  };


  //customer registration
  customerRegister = (data) => {
    return this.init().post("/user/auth/register", data)
  }

  //customer registration
  vendorRegister = (data) => {
    return this.init().post("/vendor/auth/register", data)
  }
  // login
  login = (data) => {
    return this.init().post("/common/auth/login", data)
  }

  //fotgot password send email
  forgotPassword = (data) => {
    return this.init().post("/common/auth/forgot-password", data)
  }

  //verify otp
  verifyOtp = (data) => {
    return this.init().post("/common/auth/verify-otp", data)
  }

  //reset password
  resetPassword = (data) => {
    return this.init().post("/common/auth/reset-password", data)
  }

  //----------------------------------------------------------customer-----------------------------------


  getCustomerProfile = (data) => {
    const profileUrl = "/common/setting/get-userprofile";
    return this.init().get(profileUrl)
  }

  updateCustomerBasicDetails = (data) => {
    return this.init().put("/common/setting/basic-details", data)
  }

  updateCustomerPassword = (data) => {
    return this.init().put("/common/setting/password", data)
  }

  addCustomerBillingAdress = (data) => {
    return this.init().post("/common/setting/billing-address", data)
  }



  updateCustomerBilling = (data) => {
    console.log("data", data);

    return this.init().put(`/common/setting/billing-address/${data?.id}`, data?.values)
  }

  addCustomerShippingAdress = (data) => {
    return this.init().post("/common/setting/shipping-address", data)
  }

  updateCustomerShipping = (data) => {
    return this.init().put(`/common/setting/shipping-address/${data?.id}`, data?.values)
  }


  //----------------------------------------------------accountuser--------------------------------------
  addAccountUser = (data) => {
    return this.init().post("/common/setting/accountuser", data)
  }

  updateAccountUser = (data) => {
    return this.init().put(`/common/setting/accountuser/${data?.id}`, data?.values)
  }

  getAllAccountUsers = (data) => {
    return this.init().get(`/common/setting/accountuser${data}`)
  }

  getAccountuserDetails = (id) => {
    return this.init().get(`/common/setting/accountuser/${id}`)
  }

  deleteAccountUser = (id) => {
    return this.init().delete(`/common/setting/accountuser/${id}`)
  }

  changeAccountuserPassword = (data) => {
    return this.init().put(`/common/setting/changeAccountUserPassword/${data.id}`, data?.values)
  }

  //---------------------------------------------------------vendor----------------------------------------


  getManufacturer = (data) => {
    return this.init().get("/common/manufacturer")
  }

  //---------------------------------------------------------categories----------------------------------


  topCategory = (data) => {
    return this.init().get("/common/appearance/popular-categories", data)
  }

  //category
  getAllCategory = (data) => {
    return this.init().get("/common/category", data)
  }

   //search
   smartSearch = (data, config = {}) => {
    return this.init().get(`/user/smartsearch${data}`, config)
  }

  //getSubcategories
  getSubcategory = (id) => {
    return this.init().get(`/common/subcategory/${id}`)
  }

  // --------------------------------------------------------product----------------------------------------

  //getProducts
  getProduct = (data) => {
    return this.init().post(`/common/getProduct`,data)
  }

  getProductDetails = (id) => {
    return this.init().get(`/common/product/${encodeURIComponent(id)}`)
  }

  getSimilarProducts = (id) => {
    return this.init().get(`/user/dashboard/get-similar-product${id}`)
  }

  getfilterproductcount = (selectedAttributes) => {
    return this.init().post(`/common/filterProductsByAtributesCount`, selectedAttributes)
  }

  getfilterproduct = (data) => {
    return this.init().post(`/common/filterProductsByAttributes`,data)
  }


  
  getProductcount = (data) => {
   
    return this.init().post(`/common/getFilteredProductCounts`,data)
  }
  

  //-------------------------------------------------------cart--------------------------------------------
  addToCart = (data) => {
    return this.init().post(`/common/cart/add-product`, { products: data })
  }

   sendenquirytooutofstockproducts = (data) => {
    return this.init().post(`/common/sendEnquiryToOutofstockproducts`, data)
  }


  //getAllCartItems
  getCartDetails = (id) => {
    return this.init().get('/common/cart/products')
  }

  deleteCartProducts = (id) => {
    return this.init().delete(`common/cart/delete-product/${id}`)
  }

  updateCart = (data) => {
    return this.init().put(`/common/cart/update-product/${data.id}`, { quantity: data.quantity })
  }

  placeOrder = (data) => {
    return this.init().post(`/common/cart/checkout`, data)
  }
  //----------------------------------------------------------schedule------------------------------------
  addToSchedule = (data) => {
    return this.init().post(`/common/schedule-cart/add-product`, { products: data })
  }

  getScheduleDetails = (id) => {
    return this.init().get('/common/schedule-cart/products')
  }

  deleteScheduleProducts = (id) => {
    return this.init().delete(`common/schedule-cart/delete-product/${id}`)
  }

  updateSchedule = (data) => {
    return this.init().put(`/common/schedule-cart/update-product/${data.id}`, data)
  }

  scheduleCheckout = (data) => {
    return this.init().post(`/common/schedule-cart/checkout`, data)
  }

  //scheduleorder------------------------------------------------------------------------------------
  //--------------------------------------------------------------

  getCustomerStatistics = (type) => {
    return this.init().get(`/user/dashboard/statistics?type=${type}`)
  }

  getAllScheduleOrders = (data) => {
    return this.init().get(`/user/dashboard/getAllScheduledOrders${data}`)
  }

  getScheduleOrderdetails = (data) => {
    return this.init().get(`/user/dashboard/getSingleScheduleOrders/${data}`)
  }

  rescheduleOrder = (data) => {
    return this.init().put(`/user/dashboard/reschedule-order/${data?.id}`,data)
  }

  uploadSchedulePurchaseOrder = (data) => {
    return this.init().put(`/user/dashboard/schedule-order/${data?.id}/purchase-order`, { purchaseOrderUri: data?.purchaseOrderUri })
  }



  //-----------------------------------------------sample request------------------------------------------
  sampleRequest = (data) => {
    return this.init().post(`/common/sample-request/new-sample/${data?.id}`, data?.values)
  }


  //Tools
  //------------------------------------------------cross-reference-------------------------------------

  getcrossProduct = (data) => {
    return this.init().get(`/common/crossReference${data}`)
  }

  getExactSearch = (data) => {
    return this.init().get(`/common/crossReference/exactSearch${data}`)
  }

  compareProduct = (data) => {
    return this.init().get(`/common/crossReference/compare${data}`)
  }





  //wizard tool--------------------------------------------------------------------
  //----------------------------------
  sendWizardEnquiry = (data) => {
    return this.init().post(`/common/wizard/createWizardEnquiry`, data)
  }

  //appearences---------------------------------------------------------------------------

  appearences = () => {
    return this.init().get("/common/getAllAppearances")
  }

  allcategories = () => {
    return this.init().get("/common/nav/getCategoryHeirarchy")
  }

  //-----------------------------------------upload------------------------------------------------
  getPutSignedUrl = (data) => {
    return this.init().post("/common/get-put-url", data)
  }


  //bom

  getMatchedProducts = (data) => {
    return this.init().post("/common/bom/matchproducts", { data })
  }

  getAlterProducts = (data) => {
    return this.init().get(`/common/bom/getProductWithAlternates${data}`)
  }

  sendBomEnquiry = (data) => {
    return this.init().post(`/common/bom/sendBomEnquiry`, data)
  }

  getBomEnquiry = (data) => {
    return this.init().get(`/common/bom/getAllBomEnquiries${data}`, { data })
  }

  getBomEnquirydetails = (data) => {
    return this.init().get(`/common/bom/getEnquiryDetails/${data}`)
  }

  createBomOrder = (data) => {
    return this.init().post("/common/bom/createBomOrder", data)
  }

  //poorder---------------------------------------------------------------------------
  //----------------------------------------
  createPoOrder = (data) => {
    return this.init().post("/common/poorder/createpoOrder", data)
  }

  //wizard enq

  getWizardEnquiry = (data) => {
    return this.init().get(`/common/wizard/getAllwizardEnquiries${data}`, { data })
  }

  getWizardEnquirydetails = (data) => {
    return this.init().get(`/common/wizard/getWizardEnquiryDetails/${data}`)
  }

  createWizardOrder = (data) => {
    return this.init().post("/common/wizard/createwizardOrder", data)
  }

  //EXCESS INVENTORY---------------------------------------------------------------------------
  //-------------------------------------------------------

  sendExcessEnquiry = (data) => {
    return this.init().post("/common/excessinventory/sendexcessinventoryEnquiry", data)
  }

  getExcessEnquiry = (data) => {
    return this.init().get(`/common/excessinventory/getAllexcessinventoryEnquiries${data}`, { data })
  }

  getExcessEnquirydetails = (data) => {
    return this.init().get(`/common/excessinventory/getexcessinventoryEnquiryDetails/${data}`)
  }

  createExcessOrder = (data) => {
    return this.init().post("/common/excessinventory/createexcessinventoryOrder", data)
  }


  uploadExcessEnquiry = (data) => {
    return this.init().post("/common/excessinventory/uploadexcessinventoryEnquiry", data)
  }


  getExcessData = (data) => {
    return this.init().post(`/common/excessinventory/getExcessStock`,data)
  }

  deleteExcessStock = (productNumber) => {
    return this.init().delete(`/common/excessinventory/deleteExcessStock/${encodeURIComponent(productNumber)}`)
  }

  getUploadedExcessdata = (data) => {
    return this.init().get(`/common/excessinventory/getAlluploadedexcessinventoryEnquiries${data}`)
  }


  getExcessStockdetails = (data) => {
    return this.init().get(`/common/excessinventory/getuploadedexcessinventoryEnquiryDetails/${data}`)
  }

  deleteProductFromvendorExcess = (data) => {
    return this.init().put(`/common/excessinventory/deletePartFromvendorExcessInventory/${data?.id}`, data)
  }


  getExcessStockcount = (data) => {
   
    return this.init().post(`/common/excessinventory/getExcessStockCounts`,data)
  }
  
  //revievedEnquiries------------------------------------------------------
  //-----------------------------------------------

  getRecievedEnquiries = (data) => {
    return this.init().get(`/vendor/vendorEnquiry${data}`)
  }

  getRecievedDetails = (data) => {
    return this.init().get(`/vendor/vendorEnquiry/${data}`)
  }

  createQuote = (data) => {
    return this.init().put(`/vendor/createenquiryQuote/${data.id}`, data?.values)
  }

  createBatchQuote = (data) => {
    return this.init().put(`/vendor/createenquiryQuote/batch/${data.id}`, { quotes: data?.quotes })
  }

  //received orders---------------------------------------------
  //---------------------------------------------
  getAllRecievedOrders = (data) => {
    return this.init().get(`/vendor/vendorOrder${data}`)
  }

  getRecievedOrderDetails = (data) => {
    return this.init().get(`/vendor/vendorOrder/${data}`)
  }

  updateRecievedOrderStatus = (id, status) => {
    return this.init().put(`/vendor/vendorOrder/${id}/status`, { status })
  }

  uploadVendorPurchaseOrder = (id, data) => {
    return this.init().put(`/vendor/vendorOrder/${id}/purchase-order`, data)
  }


  //pooorders

  getPoOrder = (data) => {
    return this.init().get(`/common/getpoorder${data}`)
  }
  getCartOrder = (data) => {
    return this.init().get(`/common/cartorder${data}`)
  }
  getCartOrderDetails = (data) => {
    return this.init().get(`/common/cartorder/${data}`)
  }


  // notification
  getNotification = (data, showAll) => {
    return this.init().get(`/common/get-unreadmessages/${data}?showAll=${showAll}`)
  }
  markAsRead = (data) => {
    return this.init().put(`/common/mark-read-message/${data}`)
  }
  markAllAsReaded = (data) => {
    return this.init().put(`/common/mark-all-as-read/${data}`)
  }
  getNotificationCount = () => {
    return this.init().get(`/common/user/get-unread-count`)
  }

  getPoOrderDetails = (data) => {
    return this.init().get(`/common/getPoOrderdetails/${data}`)
  }

  //contactus

 contactus = (data) => {
    return this.init().post(`/common/contactUs`,data)
  }
}

const api = new Api();

export default api
